<template>
  <div class="qrcode-card">

    <div class="qrcode-card-main"> {{createqrcodeLink}}
      <el-row > 
        <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24" class="card-body">
          <p style="text-align:left;color:black;font-weight: bold;">
            We generated a QR code for your profile. You can save this image and put it anywhere for personal use while TalentSensus will house your online profile. <br> <br>
            If you want to check it out scan the QR code on the side using your mobile app, or <el-button type="text" style="text-decoration:underline;" @click="checkIfProfileIsPublic">click here</el-button>
          </p>
        </el-col>
        <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="card-body qr-white-bg" style="background-color:white;border: 1px solid rgb(179, 240, 255);border-radius:3%;">
          <div class="center" id="qr-canvas" ref="qrcode">             
            <qrcode-vue :value="qrcodeLink" :size="size" level="H" style="text-align:center"></qrcode-vue>
          </div>
          <div :style="downloadStyle">
            <i @click="saveQrCode" class="fas fa-download" style="font-size:13px;"></i>&nbsp;<el-button type="text" class="dl-qr-cd" style="text-decoration:underline;" @click="saveQrCode">Download QR Code</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :visible="settingDialogVisible" :show-close="true" width="400px" title="Information">
      <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="onCloseDialog(null)">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>

      <p style="color:black;">Your profile is not set to be published. <br> 
      Click <span style="font-weight: bold;">“Cancel”</span> to close this message.</p> 

      <span class="dialog-footer ts-app-shell--header_actions flexed" style="margin-top:30px;padding-left: 140px;">
        <button @click.prevent="onCloseDialog(null)" class="ts-btn ts-btn-small ts-btn-dblue" > Cancel </button>
      </span>
      
    </el-dialog> 

    <el-dialog
      :visible="sgaDialogVisible" :show-close="true" width="400px" title="Information">
      <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="onCloseDialog(null)">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
  
      <p style="color:black;">Your profile is not set to be published. <br> <br>
      Click <span style="font-weight: bold;">“Settings”</span> to change the configuration or <span style="font-weight: bold;">“Cancel”</span> to close this message.</p> 

      <span class="dialog-footer ts-app-shell--header_actions flexed" style="margin-top:30px;padding-left:80px;">
        <button @click.prevent="goToProfilePageSettings" class="ts-btn ts-btn-small ts-btn-white"> Settings </button>
        <button @click.prevent="onCloseDialog(null)" class="ts-btn ts-btn-small ts-btn-dblue"> Cancel </button>
      </span>
      
    </el-dialog>

  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  props: {
    userId: {
      type: String,
      default() {
        return null;
      },
    },
    setToPublic: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fromSettingPage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    downloadStyle: {
      type: String,
      default: ''
    }, 
  },
  computed: {
    createqrcodeLink() {
      this.qrcodeLink = window.location.host + "/qr-landing/" + this.$props.userId;          
    },
    currentUser() {
      // if (this.$store.state.apprentice.current_user) {
      //   return this.$store.state.account.current_user;
      // } else {
      //   return this.$store.state.account.current_user;
      // }
      return this.$store.state.account.current_user;
    },
  },
  components: {
      QrcodeVue,
    },
  data(){
    return {
      qrcodeLink: null,
      size: 150,  
      settingDialogVisible: false,
      sgaDialogVisible: false,
    }
  },
  methods: {
    checkIfProfileIsPublic(){

      //if from SGA Thank you page
      if(!this.$props.fromSettingPage) {
        if (!this.$props.setToPublic) {
          this.sgaDialogVisible = true;
        } else {
          const route = this.$router.resolve({ name: 'QRLanding', params: { userid: this.$props.userId } });
          window.open(route.href, '_blank');
        }
      } 
      // else from Profile setting page
      else {
        if (!this.$props.setToPublic) {
          this.settingDialogVisible = true;
        } else {
          const route = this.$router.resolve({ name: 'QRLanding', params: { userid: this.$props.userId } });
          window.open(route.href, '_blank');
        }
      }
    },
    onCloseDialog(done) {
      this.settingDialogVisible = false;
      this.sgaDialogVisible = false;
    },
    goToProfilePageSettings() {
        if (this.userHasRole(process.env.VUE_APP_ROLE_JOB_SEEKER) ) {
            this.$router.push({ name: 'JobSeekerProfilePageSetting' });
        } else {
          this.$router.push({ name: 'ApprenticeProfilePageSetting' });
        }
    },
    async saveQrCode() {
      const el = this.$refs.qrcode;
      const options = {
        type: 'dataURL'
      }

      let output = await this.$html2canvas(el, options);
      var a = document.createElement("a"); 
      a.href = output;
      a.download = `${this.currentUser.fullName}.png`;
      a.click();
    },
  }
}
</script>

<style scoped>
.center {
  margin: auto;
  padding: 5px;
}

.card-body {
  height: 170px;
}


@media screen and (max-width: 759px) {
  .qr-white-bg {
    margin-top: 40px
  }

  .ts-app-shell_fh .dl-qr-cd{
    margin-top: 10px;
  }
}
</style>